import { getLocalStorageData } from '../../utils/helper';
import { APP_API_URL_V2 } from '../../utils/xhr-instance';
import { axiosInstanceV2 } from '../axios';

export async function createSalesReturn(data) {
	const API_URL = `${APP_API_URL_V2}/sales/return`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err?.response?.data;
		});
}

export async function updateSalesReturn(id, data) {
	const API_URL = `${APP_API_URL_V2}/sales/return/${id}`;
	const token = getLocalStorageData();

	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function deleteSalesReturn(data) {
	const API_URL = `${APP_API_URL_V2}/sales/return/delete`;
	const token = getLocalStorageData();
	try {
		await axiosInstanceV2.delete(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
			data: data,
		});
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function createCreditFromSalesReturn(data) {
	const API_URL = `${APP_API_URL_V2}/sales/return/create-credit-note`;
	const token = getLocalStorageData();
	try {
		await axiosInstanceV2.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
			data: data,
		});
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function getSalesReturnDetail(id) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.get(`${APP_API_URL_V2}/sales/return/${id}`, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function fetchSalesReturnNumber() {
	const token = getLocalStorageData();
	try {
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/sales/return/number`, {
			headers: {
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return data.data.sales_return;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function fetchSalesReturnType() {
	const token = getLocalStorageData();
	try {
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/sales/return/type`, {
			headers: {
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function sendEmail(id, data) {
	const token = getLocalStorageData();
	try {
		const { res } = await axiosInstanceV2.post(
			`${APP_API_URL_V2}/sales/return/${id}/send/email`,
			data,
			{
				headers: {
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
		return res;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function getSalesReturnList(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(`${APP_API_URL_V2}/sales/return/list`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function fetchSalesReturnDetails(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(`${APP_API_URL_V2}/sales/return/details`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function updateSalesReturnBulkStatus(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(
			`${APP_API_URL_V2}/sales/return/update/status/bulk`,
			data,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function updateSalesReturnStatus(id, status) {
	const API_URL = `${APP_API_URL_V2}/sales/return/${id}?status=${status}`;
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.patch(
			API_URL,
			{},
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function adjustSalesReturnRefundAmount(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(`${APP_API_URL_V2}/sales/return/adjust-amount`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function generateSalesReturnsPdf(id, merge = false) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/sales/return/generate-pdf?ids=${id}&merge=${merge}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data?.data.signed_urls[0];
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}
